export const LOCAL_SESSION = 'session';
export const LOCAL_SESSION_TIME = 3600000;
